import { ChevronLeftSIcon, ChevronRightSIcon } from 'tdesign-icons-react';

interface IButtonPaging {
  className?: string;
  page: number;
  next: () => void;
  prev: () => void;
  total: number;
}
const ButtonPaging = ({
  page,
  next,
  prev,
  total,
  className,
}: IButtonPaging) => {
  const prevDisabled = page <= 1;
  const nextDisabled = page >= total;
  const enabledColorClassName = 'border-[#121C59] text-[#121C59]';
  const disabledColorClassName = 'border-[#121C59]/40 text-[#121C59]/40';
  return (
    <div className={`flex items-center justify-end mt-[48px] ${className}`}>
      <div
        className={`size-10 rounded-full border-[1.5px] border-solid flex items-center justify-center cursor-pointer ${
          prevDisabled ? disabledColorClassName : enabledColorClassName
        }`}
        onClick={!prevDisabled ? prev : undefined}
      >
        <ChevronLeftSIcon size={24}></ChevronLeftSIcon>
      </div>

      <div className="text-sm font-400 flex items-center justify-center text-[#121C59]/60 min-w-16">
        {page}/{total}
      </div>
      <div
        className={`size-10 rounded-full border-[1.5px] border-solid flex items-center justify-center cursor-pointer ${
          nextDisabled ? disabledColorClassName : enabledColorClassName
        }`}
        onClick={!nextDisabled ? next : undefined}
      >
        <ChevronRightSIcon size={24}></ChevronRightSIcon>
      </div>
    </div>
  );
};

export default ButtonPaging;
